var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 1.66675C5.90866 1.66675 2.16699 5.40841 2.16699 10.0001C2.16699 14.5917 5.90866 18.3334 10.5003 18.3334C15.092 18.3334 18.8337 14.5917 18.8337 10.0001C18.8337 5.40841 15.092 1.66675 10.5003 1.66675ZM14.4837 8.08341L9.75866 12.8084C9.64199 12.9251 9.48366 12.9917 9.31699 12.9917C9.15033 12.9917 8.99199 12.9251 8.87533 12.8084L6.51699 10.4501C6.27533 10.2084 6.27533 9.80841 6.51699 9.56675C6.75866 9.32508 7.15866 9.32508 7.40033 9.56675L9.31699 11.4834L13.6003 7.20008C13.842 6.95842 14.242 6.95842 14.4837 7.20008C14.7253 7.44175 14.7253 7.83341 14.4837 8.08341Z",
    fill: "#2EBB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green_tick.4a7149ccd740f4826e0f2cebb3548879.svg";
export { ForwardRef as ReactComponent };